export default "__VITE_ASSET__CcULN5Me__"